module.exports = __webpack_public_path__ + "media/images/avatar/development/parents/3-d7dde956b8d4ed7137083e3979d1adb4.jpg";